import {
  RegionCaptureProfile,
  SaveProfileDTO,
  SaveRegionCaptureProfilesDTO,
} from 'business/models/Models';
import CaptureProfileService from 'business/services/CaptureProfileService';
import RMCheckBox from 'components/customComponents/Controls/RMCheckbox';
import RMModal from 'components/modal/RMModal';
import RMTable from 'components/customComponents/Controls/RMTable';
import { LabelRadioBox } from 'components/customComponents/Layers/InputGroups';
import React, { useEffect, useState } from 'react';
import { getNewId } from 'utils/Global';
import { fetchImageSettingsProps, tableHeader } from './Constants';
import { onClickSelectedOption } from './utils';
import { useFetchImageSettings } from './hooks';

export interface Props {
  setShowModal: any;
  showModal: boolean;
  roiId: number;
}
export const ImageSettings = (props: Props) => {
  const { setShowModal, showModal, roiId } = props;
  const [values, setValues] = useState([]);
  const [isUseAsExperiment, setIsUseAsExperiment] = useState<boolean>();
  const [regionCaptureProfiles, setRegionCaptureProfiles] = useState<
    RegionCaptureProfile[]
  >([]);
  const [captureImageSettings, setCaptureImageSettings] = useState<SaveProfileDTO[]>([]);
  useFetchImageSettings({
    roiId: roiId,
    setCaptureImageSettings: setCaptureImageSettings,
    setIsUseAsExperiment: setIsUseAsExperiment,
    setRegionCaptureProfiles: setRegionCaptureProfiles,
    showModal: showModal,
  } as fetchImageSettingsProps);

  useEffect(() => {
    return () => {
      setRegionCaptureProfiles([]);
      setCaptureImageSettings([]);
    };
  }, []);
  useEffect(() => {
    if (captureImageSettings?.length > 0) {
      setupTable();
    }
  }, [isUseAsExperiment, regionCaptureProfiles, captureImageSettings]);

  const getCheckedBox = (setting) => {
    return (
      <RMCheckBox
        isChecked={setting.isImagingEnabled}
        onChange={(e) => {
          onClickSelectedOption({
            isEnabled: e.target.checked,
            imageSettingId: setting.id,
            regionCaptureProfiles: regionCaptureProfiles,
            setRegionCaptureProfiles: setRegionCaptureProfiles,
          });
        }}
        isDisabled={isUseAsExperiment}
        style={{ height: '15px' }}
      ></RMCheckBox>
    );
  };

  const setupTable = () => {
    const imageSettings = captureImageSettings
      .filter((cp) => cp.enabled === true)
      .map((cp) => {
        const regCaptureProfile = regionCaptureProfiles?.find(
          (rcp) => rcp.captureProfileId === cp.id,
        );
        return {
          id: regCaptureProfile?.id ?? getNewId(),
          name: cp.name,
          isImagingEnabled: regCaptureProfile?.imagingEnabled ?? false,
        };
      });
    const tableData = imageSettings?.map((setting) => {
      const entry = {
        name: setting.name,
        isImagingEnabled: getCheckedBox(setting),
      };
      return entry;
    });
    setValues(tableData);
  };

  const saveImageSettings = async () => {
    const captureProfileService = new CaptureProfileService();
    const saveRegionCaptureProfilesDTO = new SaveRegionCaptureProfilesDTO();
    saveRegionCaptureProfilesDTO.regionCaptureProfiles = regionCaptureProfiles;
    saveRegionCaptureProfilesDTO.isDeleteProfiles = isUseAsExperiment;
    const isSaved = await captureProfileService.saveRegionCaptureProfiles(
      saveRegionCaptureProfilesDTO,
    );
    if (isSaved) {
      setShowModal(false);
    }
  };

  return (
    <>
      <RMModal
        id='commandpanel-exptools-imagesettings-modals'
        showModal={showModal}
        setShowModal={setShowModal}
        okButtonText="Proceed"
        noButtonText="Cancel"
        onCancel={() => {
          setShowModal(false);
        }}
        showButtons={true}
        onOk={saveImageSettings}
        body={
          <>
            <div id='commandpanel-exptools-imagesettings-body-message' className="font-bold" style={{ marginBottom: '2%' }}>
              Please select an imaging setting(s) for this ROI.
            </div>
            <LabelRadioBox
              labelText={'Same as Experiment'}
              radioValue={isUseAsExperiment}
              onChange={() => {
                setIsUseAsExperiment(true);
              }}
              name="sameAsExperiment"
              disabled={false}
              style={{ marginBottom: '2%' }}
            />
            <LabelRadioBox
              labelText={'Customize Settings'}
              radioValue={!isUseAsExperiment}
              onChange={() => {
                setIsUseAsExperiment(false);
              }}
              name="sameAsExperiment"
              disabled={false}
              style={{ marginBottom: '2%' }}
            />
            <RMTable
              columns={tableHeader}
              data={values}
              tableClass="auto-score-table"
            ></RMTable>
          </>
        }
        heading="Region Imaging Settings"
      />
    </>
  );
};
